export default __webpack_public_path__ + "static/media/bubp.25dab700.png";